var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"back"}},[_c('van-nav-bar',{attrs:{"title":_vm.title},on:{"click-right":_vm.onClickRight},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"friends-o","size":"22"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }